module.exports = __webpack_public_path__ + "static/media/best-buy-egift-card.26255c7e.png";